webpackJsonp([138153399639610],{

/***/ 667:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _Icon3 = __webpack_require__(52);
	
	var _Icon4 = _interopRequireDefault(_Icon3);
	
	var _Button3 = __webpack_require__(51);
	
	var _Button4 = _interopRequireDefault(_Button3);
	
	var _Image3 = __webpack_require__(73);
	
	var _Image4 = _interopRequireDefault(_Image3);
	
	var _Header3 = __webpack_require__(29);
	
	var _Header4 = _interopRequireDefault(_Header3);
	
	var _Container3 = __webpack_require__(26);
	
	var _Container4 = _interopRequireDefault(_Container3);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(25);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(50);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _disqusReact = __webpack_require__(93);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var h3style = {
	  opacity: 0.5,
	  marginTop: 0
	};
	
	var description = 'Часто задоваемые вопросы про наши Фэйковые Авиабилеты. Как быстро мы их делаем. Какие риски. PNR. Что делать в аэропорту и т.д. Читай дальше …';
	
	var FAQ = function FAQ(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    _Container4.default,
	    { text: true },
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        '\u0427\u0430\u0441\u0442\u043E \u0417\u0430\u0434\u0430\u0432\u0430\u0435\u043C\u044B\u0435 \u0412\u043E\u043F\u0440\u043E\u0441\u044B - Fake Flight Tickets'
	      ),
	      _react2.default.createElement('meta', {
	        name: 'twitter:title',
	        content: '\u0427\u0430\u0441\u0442\u043E \u0417\u0430\u0434\u0430\u0432\u0430\u0435\u043C\u044B\u0435 \u0412\u043E\u043F\u0440\u043E\u0441\u044B - Fake Flight Tickets'
	      }),
	      _react2.default.createElement('meta', { name: 'description', content: description }),
	      _react2.default.createElement('meta', { name: 'twitter:description', content: description }),
	      _react2.default.createElement('meta', { name: 'twitter:image', content: '/opengraph-image.ru.jpg' }),
	      _react2.default.createElement('meta', { property: 'og:image', content: '/opengraph-image.ru.jpg' })
	    ),
	    _react2.default.createElement(
	      _Header4.default,
	      { as: 'h1', textAlign: 'center' },
	      '\u0427\u0430\u0441\u0442\u043E \u0417\u0430\u0434\u0430\u0432\u0430\u0435\u043C\u044B\u0435 \u0412\u043E\u043F\u0440\u043E\u0441\u044B'
	    ),
	    _react2.default.createElement(
	      _Header4.default,
	      { as: 'h3', textAlign: 'center', style: h3style },
	      '(\u043F\u043E\u043A\u0430 \u043D\u0430 \u0430\u043D\u0433\u043B\u0438\u0439\u0441\u043A\u043E\u043C, \u043D\u043E \u043C\u044B \u0441\u043A\u043E\u0440\u043E \u043F\u0435\u0440\u0435\u0432\u0435\u0434\u0451\u043C)'
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(
	      'h2',
	      null,
	      '\u2708\uFE0F \u0427\u0442\u043E \u0442\u0430\u043A\u043E\u0435 ',
	      data.site.siteMetadata.ru.title,
	      '?'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      data.site.siteMetadata.ru.title,
	      ' \u2014 \u044D\u0442\u043E \u0441\u0435\u0440\u0432\u0438\u0441, \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u043F\u043E\u043C\u043E\u0433\u0430\u0435\u0442 \u0432\u0430\u043C \u0440\u0435\u0448\u0438\u0442\u044C \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0443 \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u044F "\u0434\u043E\u043A\u0430\u0437\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0435\u043D\u0438\u044F \u043F\u043E\u0435\u0437\u0434\u043A\u0438". \u041C\u043D\u043E\u0433\u0438\u0435 \u0430\u0432\u0438\u0430\u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438 \u0438 \u0441\u0442\u0440\u0430\u043D\u044B \u0442\u0440\u0435\u0431\u0443\u044E\u0442 \u0434\u043E\u043A\u0430\u0437\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 \u0442\u043E\u0433\u043E, \u0447\u0442\u043E \u0432\u044B \u043D\u0430\u043C\u0435\u0440\u0435\u043D\u044B \u043F\u043E\u043A\u0438\u043D\u0443\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0443, \u043F\u0440\u0435\u0436\u0434\u0435 \u0447\u0435\u043C \u0432\u0430\u043C \u0440\u0430\u0437\u0440\u0435\u0448\u0430\u0442 \u0441\u0435\u0441\u0442\u044C \u043D\u0430 \u0441\u0430\u043C\u043E\u043B\u0435\u0442. \u041C\u044B \u0432\u0441\u0435 \u043B\u044E\u0431\u0438\u043C \u0433\u0438\u0431\u043A\u043E\u0441\u0442\u044C \u0438 \u0447\u0430\u0441\u0442\u043E \u043D\u0435 \u0437\u043D\u0430\u0435\u043C, \u043A\u0443\u0434\u0430 \u043C\u044B \u0445\u043E\u0442\u0438\u043C \u043F\u043E\u043B\u0435\u0442\u0435\u0442\u044C. \u0422\u0440\u0430\u0442\u0438\u0442\u044C \u0441\u043E\u0442\u043D\u0438 \u0434\u043E\u043B\u043B\u0430\u0440\u043E\u0432, \u043C\u0435\u0441\u044F\u0446\u044B \u0434\u043E \u043F\u043E\u0435\u0437\u0434\u043A\u0438, \u2014 \u044D\u0442\u043E \u0434\u043E\u0440\u043E\u0433\u043E\u0435, \u0441\u0442\u0440\u0435\u0441\u0441\u043E\u0432\u043E\u0435 \u0438\u0441\u043F\u044B\u0442\u0430\u043D\u0438\u0435, \u043A\u043E\u0442\u043E\u0440\u043E\u0435 \u0443\u0431\u0438\u0432\u0430\u0435\u0442 \u0432\u0430\u0448\u0443 \u0441\u0432\u043E\u0431\u043E\u0434\u0443.',
	      _react2.default.createElement('br', null),
	      '\u041C\u044B \u0442\u043E\u0436\u0435 \u043D\u0435 \u043B\u044E\u0431\u0438\u043C \u044D\u0442\u043E, \u0438 \u0441\u043E\u0437\u0434\u0430\u043B\u0438 \u044D\u0442\u043E\u0442 \u0433\u0435\u043D\u0435\u0440\u0430\u0442\u043E\u0440 \u0444\u0435\u0439\u043A\u043E\u0432\u044B\u0445 \u0430\u0432\u0438\u0430\u0431\u0438\u043B\u0435\u0442\u043E\u0432.'
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      '\u2699\uFE0F How does ',
	      data.site.siteMetadata.ru.title,
	      ' work?'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u041C\u044B \u0431\u0435\u0440\u0435\u043C \u043E\u0431\u0449\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0443\u044E \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E \u043E \u0440\u0435\u0430\u043B\u044C\u043D\u044B\u0445 \u0440\u0435\u0439\u0441\u0430\u0445 \u043F\u043E \u0432\u0441\u0435\u043C\u0443 \u043C\u0438\u0440\u0443, \u043E\u0431\u044A\u0435\u0434\u0438\u043D\u044F\u0435\u043C \u0435\u0435 \u0441 \u0432\u0430\u0448\u0438\u043C\u0438 \u043B\u0438\u0447\u043D\u044B\u043C\u0438 \u0434\u0430\u043D\u043D\u044B\u043C\u0438 \u0438 \u0433\u0435\u043D\u0435\u0440\u0438\u0440\u0443\u0435\u043C \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442, \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0430\u044E\u0449\u0438\u0439 \u0431\u0440\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435, \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u0432\u044B\u0433\u043B\u044F\u0434\u0438\u0442 \u0442\u043E\u0447\u043D\u043E \u0442\u0430\u043A \u0436\u0435, \u043A\u0430\u043A \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u0439! \u041F\u0440\u0430\u043A\u0442\u0438\u0447\u0435\u0441\u043A\u0438 \u043D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E \u043E\u0442\u043B\u0438\u0447\u0438\u0442\u044C \u0440\u0435\u0430\u043B\u044C\u043D\u043E\u0435 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 \u043F\u043E\u043B\u0435\u0442\u0430 \u043E\u0442 \u0442\u043E\u0433\u043E, \u0447\u0442\u043E \u043C\u044B \u0433\u0435\u043D\u0435\u0440\u0438\u0440\u0443\u0435\u043C. ',
	      _react2.default.createElement(
	        'i',
	        null,
	        '\u0415\u0441\u043B\u0438 \u0442\u043E\u043B\u044C\u043A\u043E'
	      ),
	      ' \u0432\u044B \u043D\u0435 \u043F\u043E\u0437\u0432\u043E\u043D\u0438\u0442\u0435 \u0438 \u043D\u0435 \u043F\u0440\u043E\u0432\u0435\u0440\u0438\u0442\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C \u0431\u0438\u043B\u0435\u0442\u0430 \u0443 \u043D\u0438\u0445.'
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      '\u2705 \u041A\u0430\u043A\u0430\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u0440\u0435\u0430\u043B\u044C\u043D\u0430\u044F, \u0430 \u043A\u0430\u043A\u0430\u044F \u043D\u0435\u0442?'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u041C\u044B \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u043C \u0440\u0435\u0430\u043B\u044C\u043D\u044B\u0439 \u0448\u0430\u0431\u043B\u043E\u043D \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F \u0431\u0440\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u043F\u043E\u043F\u0443\u043B\u044F\u0440\u043D\u043E\u0433\u043E \u0441\u0430\u0439\u0442\u0430 \u0431\u0440\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F, \u0440\u0435\u0430\u043B\u044C\u043D\u0443\u044E \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E \u043E \u0440\u0435\u0439\u0441\u0435: \u0446\u0435\u043D\u0443, \u043D\u043E\u043C\u0435\u0440 \u0440\u0435\u0439\u0441\u0430, \u0434\u0430\u0442\u0443 \u0438 \u0432\u0440\u0435\u043C\u044F \u0432\u044B\u043B\u0435\u0442\u0430, \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C, \u043F\u0435\u0440\u0435\u0441\u0430\u0434\u043A\u0438 \u0438 \u0442.\u0434. \u041C\u044B \u0433\u0435\u043D\u0435\u0440\u0438\u0440\u0443\u0435\u043C \u043D\u0430\u0448 \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u0430 \u0438 \u043E\u043D',
	      ' ',
	      _react2.default.createElement(
	        'b',
	        null,
	        '\u043D\u0435 \u0440\u0435\u0430\u043B\u0435\u043D'
	      ),
	      '.',
	      _react2.default.createElement('br', null),
	      '\u0427\u0438\u0442\u0430\u0439\u0442\u0435 \u0431\u043E\u043B\u044C\u0448\u0435 \u043E \u0440\u0435\u0430\u043B\u044C\u043D\u043E\u0439 \u0438 \u0441\u0433\u0435\u043D\u0435\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u0432',
	      ' ',
	      _react2.default.createElement(
	        'a',
	        { href: '/blog/what-is-real-and-what-is-not' },
	        ' \u044D\u0442\u043E\u043C \u0431\u043B\u043E\u0433\u0435'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      '\uD83D\uDEC2 \u041A\u0430\u043A \u0441\u0435\u0431\u044F \u0432\u0435\u0441\u0442\u0438 \u0432 \u0430\u044D\u0440\u043E\u043F\u043E\u0440\u0442\u0443?'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u0412 \u0437\u0430\u0432\u0438\u0441\u0438\u043C\u043E\u0441\u0442\u0438 \u043E\u0442 \u0432\u0430\u0448\u0435\u0439 \u0446\u0435\u043B\u0438 \u0438 \u043F\u0430\u0441\u043F\u043E\u0440\u0442\u0430 \u0432\u0430\u043C \u043C\u043E\u0433\u0443\u0442 \u043F\u043E\u0442\u0440\u0435\u0431\u043E\u0432\u0430\u0442\u044C\u0441\u044F \u0434\u043E\u043A\u0430\u0437\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0435\u043D\u0438\u044F \u043F\u043E\u0435\u0437\u0434\u043A\u0438 \u0432\u043E \u0432\u0440\u0435\u043C\u044F \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438. (\u041D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, \u0432\u044B \u043B\u0435\u0442\u0438\u0442\u0435 \u0432 \u0418\u043D\u0434\u043E\u043D\u0435\u0437\u0438\u044E).',
	      ' ',
	      _react2.default.createElement(
	        'b',
	        null,
	        '\u0412\u0430\u0448 \u043E\u043F\u044B\u0442 \u043C\u043E\u0436\u0435\u0442 \u043E\u0442\u043B\u0438\u0447\u0430\u0442\u044C\u0441\u044F'
	      ),
	      ', \u043D\u043E \u0432\u043E\u0442 \u0447\u0442\u043E \u043E\u0431\u044B\u0447\u043D\u043E \u043F\u0440\u043E\u0438\u0441\u0445\u043E\u0434\u0438\u0442 \u0441\u043E \u043C\u043D\u043E\u0439 \u0438 \u0447\u0442\u043E \u044F \u0434\u0435\u043B\u0430\u044E:',
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          '\u041A\u043E\u0433\u0434\u0430 \u0432\u0430\u043C \u043F\u043E\u0442\u0440\u0435\u0431\u0443\u044E\u0442, \u044F \u043F\u043E\u043A\u0430\u0437\u044B\u0432\u0430\u044E \u0441\u0432\u043E\u0451 \u0434\u043E\u043A\u0430\u0437\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0435\u043D\u0438\u044F \u043F\u043E\u0435\u0437\u0434\u043A\u0438'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          '\u0427\u0435\u043B\u043E\u0432\u0435\u043A, \u043E\u0442\u0432\u0435\u0447\u0430\u044E\u0449\u0438\u0439 \u0437\u0430 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044E, \u0441\u043C\u043E\u0442\u0440\u0438\u0442 \u0442\u043E\u043B\u044C\u043A\u043E \u043D\u043E\u043C\u0435\u0440 \u0440\u0435\u0439\u0441\u0430, \u0430\u0432\u0438\u0430\u043A\u043E\u043C\u043F\u0430\u043D\u0438\u044E \u0438 \u0434\u0430\u0442\u0443. \u041E\u043D \u0443\u043A\u0430\u0437\u044B\u0432\u0430\u0435\u0442 \u043F\u0430\u043B\u044C\u0446\u0435\u043C \u043D\u0430 \u043C\u0430\u0440\u0448\u0440\u0443\u0442 \u0438 \u0432\u0432\u043E\u0434\u0438\u0442 \u0435\u0433\u043E \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443.'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          '\u041F\u043E \u043C\u043E\u0435\u043C\u0443 \u043E\u043F\u044B\u0442\u0443, \u043E\u043D\u0438 \u043D\u0435 \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u0443\u044E\u0442\u0441\u044F ',
	          _react2.default.createElement(
	            'b',
	            null,
	            '\u043D\u043E\u043C\u0435\u0440\u043E\u043C \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u0430'
	          ),
	          ' \u0438 \u043D\u0435 \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u0443\u044E\u0442\u0441\u044F \u0432\u0430\u0448\u0438\u043C \u043D\u043E\u043C\u0435\u0440\u043E\u043C PNR.'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'If you are asked for your PNR confirmation number, you can always say:',
	          ' ',
	          _react2.default.createElement(
	            'i',
	            null,
	            '"\u0412\u044B \u0442\u043E\u043B\u044C\u043A\u043E \u0447\u0442\u043E \u043A\u0443\u043F\u0438\u043B\u0438 \u044D\u0442\u043E\u0442 \u0431\u0438\u043B\u0435\u0442 \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u0434\u043D\u0435\u0439 \u043D\u0430\u0437\u0430\u0434, \u043F\u043E\u044D\u0442\u043E\u043C\u0443, \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E, \u0430\u0433\u0435\u043D\u0442 \u0435\u0449\u0451 \u043D\u0435 \u0432\u044B\u0434\u0430\u043B \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u0439 \u0431\u0438\u043B\u0435\u0442"'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\u041E\u043F\u044F\u0442\u044C \u0436\u0435, \u044D\u0442\u043E \u043E\u0441\u043D\u043E\u0432\u0430\u043D\u043E \u043D\u0430 \u043C\u043E\u0435\u043C \u043B\u0438\u0447\u043D\u043E\u043C \u043E\u043F\u044B\u0442\u0435. \u0412\u0430\u0448 \u043E\u043F\u044B\u0442 \u043C\u043E\u0436\u0435\u0442 \u043E\u0442\u043B\u0438\u0447\u0430\u0442\u044C\u0441\u044F. \u0415\u0441\u043B\u0438 \u0443 \u0432\u0430\u0441 \u0435\u0441\u0442\u044C \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u0441\u043E\u0432\u0435\u0442\u044B \u0438 \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0430\u0446\u0438\u0438, \u043F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043D\u0430\u043F\u0438\u0448\u0438\u0442\u0435 \u043D\u0438\u0436\u0435.'
	      )
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      '\uD83E\uDD11 \u041E\u0442\u043B\u0438\u0447\u043D\u043E! \u0411\u0435\u0440\u0443! \u0421\u043A\u043E\u043B\u044C\u043A\u043E \u0441\u0442\u043E\u0438\u0442?'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u041C\u044B \u0432\u0437\u0438\u043C\u0430\u0435\u043C \u043F\u043B\u0430\u0442\u0443, \u043A\u0430\u043A \u0437\u0430 \u0447\u0430\u0448\u043A\u0443 \u043A\u043E\u0444\u0435 \u2615 $5',
	      _react2.default.createElement('br', null),
	      '\u0411\u044B\u0441\u0442\u0440\u043E. \u0425\u043E\u0440\u043E\u0448\u043E. ',
	      _react2.default.createElement(
	        'b',
	        null,
	        '\u0414\u0435\u0448\u0435\u0432\u043E'
	      ),
	      '!'
	    ),
	    _react2.default.createElement(_Image4.default, { src: 'https://media.giphy.com/media/A7BrncpC2Z8Ws/giphy.gif', centered: true }),
	    _react2.default.createElement(
	      'h2',
	      null,
	      '\uD83E\uDDD0 \u0411\u0438\u043B\u0435\u0442\u044B \u0440\u0435\u0430\u043B\u044C\u043D\u044B\u0435?'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u041D\u0435\u0442. \u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 \u0431\u0440\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F, \u043A\u043E\u0442\u043E\u0440\u043E\u0435 \u0432\u044B \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u0435, \u043D\u0435 \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u0440\u0435\u0430\u043B\u044C\u043D\u044B\u043C. \u041D\u043E \u043E\u043D\u043E \u043F\u043E\u043B\u043D\u043E\u0441\u0442\u044C\u044E \u043D\u0435\u043E\u0442\u043B\u0438\u0447\u0438\u043C\u043E (\u0432\u0438\u0437\u0443\u0430\u043B\u044C\u043D\u043E) \u043E\u0442 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0433\u043E.'
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      '\u041C\u043E\u0433\u0443 \u043B\u0438 \u044F \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0432\u043E\u0437\u0432\u0440\u0430\u0442?'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u041D\u0435\u0442. \u041C\u044B \u043D\u0435 \u0432\u043E\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u043C \u0434\u0435\u043D\u044C\u0433\u0438. \u041D\u0430\u0448\u0438 \u0443\u0441\u043B\u0443\u0433\u0438 \u043F\u0440\u043E\u0441\u0442\u044B \u0438 \u043F\u0440\u044F\u043C\u043E\u043B\u0438\u043D\u0435\u0439\u043D\u044B. \u0427\u0442\u043E \u0432\u044B \u0432\u0438\u0434\u0438\u0442\u0435, \u0442\u043E \u0438 \u043F\u043E\u043B\u0443\u0447\u0430\u0435\u0442\u0435. \u041A\u0440\u043E\u043C\u0435 \u0442\u043E\u0433\u043E, \u0432\u0430\u0448\u0435 \u0432\u0440\u0435\u043C\u044F \u043D\u0430\u043C\u043D\u043E\u0433\u043E \u0434\u043E\u0440\u043E\u0436\u0435, \u0447\u0435\u043C \u0442\u0440\u0430\u0442\u0438\u0442\u044C \u0435\u0433\u043E \u043D\u0430 \u0432\u043E\u0437\u0432\u0440\u0430\u0442 $5.'
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      '\u0427\u0442\u043E \u0434\u0435\u043B\u0430\u0442\u044C, \u0435\u0441\u043B\u0438 \u043C\u0435\u043D\u044F \u043E\u0442\u043A\u0430\u0437\u044B\u0432\u0430\u044E\u0442 \u0432 \u043F\u043E\u0441\u0430\u0434\u043A\u0435?'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u0412\u0435\u0440\u043E\u044F\u0442\u043D\u043E, \u044D\u0442\u043E \u043F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u043E \u043F\u043E \u0434\u0440\u0443\u0433\u043E\u0439 \u043F\u0440\u0438\u0447\u0438\u043D\u0435, \u043A\u0440\u043E\u043C\u0435 \u0432\u0430\u0448\u0435\u0433\u043E \u0434\u043E\u043A\u0430\u0437\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0435\u043D\u0438\u044F \u043F\u043E\u0435\u0437\u0434\u043A\u0438. \u0412 \u043B\u044E\u0431\u043E\u043C \u0441\u043B\u0443\u0447\u0430\u0435, \u043C\u044B \u043D\u0435 \u043D\u0435\u0441\u0435\u043C \u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u044C \u0437\u0430 \u044D\u0442\u043E. \u041D\u0438\u0436\u0435 \u044F \u0434\u0430\u043C \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u0441\u043E\u0432\u0435\u0442\u043E\u0432, \u043A\u0430\u043A \u043C\u0438\u043D\u0438\u043C\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0432\u0430\u0448\u0438 \u0440\u0438\u0441\u043A\u0438 \u0432\u043E \u0432\u0440\u0435\u043C\u044F \u043F\u043E\u0435\u0437\u0434\u043A\u0438. \uD83D\uDC47'
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      '\u0411\u043E\u043B\u0435\u0435 \u043F\u043E\u043B\u0435\u0437\u043D\u044B\u0435 \u0441\u043E\u0432\u0435\u0442\u044B:'
	    ),
	    _react2.default.createElement(
	      'ul',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'b',
	          null,
	          '\u041E\u0434\u0435\u043D\u044C\u0442\u0435\u0441\u044C \u043F\u0440\u0438\u043B\u0438\u0447\u043D\u043E'
	        ),
	        ' \u0434\u043B\u044F \u0430\u044D\u0440\u043E\u043F\u043E\u0440\u0442\u0430! \u041F\u043E\u0447\u0435\u043C\u0443? \u041A\u043E\u0433\u0434\u0430 \u0432\u044B \u0432\u044B\u0433\u043B\u044F\u0434\u0438\u0442\u0435 \u043F\u0440\u0435\u0437\u0435\u043D\u0442\u0430\u0431\u0435\u043B\u044C\u043D\u043E, \u0434\u0435\u043C\u043E\u043D\u0441\u0442\u0440\u0438\u0440\u0443\u0435\u0442\u0435 \u0441\u0432\u043E\u0439 \u0441\u0442\u0430\u0442\u0443\u0441 \u043E\u0434\u0435\u0436\u0434\u043E\u0439, \u0447\u0430\u0441\u0430\u043C\u0438 \u0438 \u0442.\u0434... \u042D\u0442\u043E \u043C\u043E\u0436\u0435\u0442 \u043F\u0440\u043E\u0438\u0437\u0432\u0435\u0441\u0442\u0438 \u043F\u043E\u043B\u043E\u0436\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u0432\u043F\u0435\u0447\u0430\u0442\u043B\u0435\u043D\u0438\u0435 \u043D\u0430 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0430\u0432\u0438\u0430\u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438. \u0418 \u043C\u0438\u043D\u0438\u043C\u0438\u0437\u0438\u0440\u0443\u0435\u0442 \u0441\u043E\u043C\u043D\u0435\u043D\u0438\u044F \u0432 \u0442\u043E\u043C, \u0447\u0442\u043E \u0443 \u0432\u0430\u0441 \u043D\u0435 \u0445\u0432\u0430\u0442\u0438\u0442 \u0434\u0435\u043D\u0435\u0433, \u0447\u0442\u043E\u0431\u044B \u043F\u043E\u043A\u0438\u043D\u0443\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0443.'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'b',
	          null,
	          '\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0430\u0432\u0438\u0430\u043A\u043E\u043C\u043F\u0430\u043D\u0438\u044E, \u043E\u0442\u043B\u0438\u0447\u043D\u0443\u044E \u043E\u0442 \u0442\u043E\u0439, \u043A\u043E\u0442\u043E\u0440\u043E\u0439 \u0432\u044B \u0441\u0435\u0439\u0447\u0430\u0441 \u043B\u0435\u0442\u0438\u0442\u0435'
	        ),
	        '. \u041D\u0430\u043F\u0440\u0438\u043C\u0435\u0440: \u0435\u0441\u043B\u0438 \u0432\u044B \u043B\u0435\u0442\u0438\u0442\u0435 \u0438\u0437 \u041A\u0443\u0430\u043B\u0430-\u041B\u0443\u043C\u043F\u0443\u0440\u0430 \u043D\u0430 \u0411\u0430\u043B\u0438 \u0441 AirAsia \u043F\u043E \u0431\u0438\u043B\u0435\u0442\u0443 \u0432 \u043E\u0434\u043D\u0443 \u0441\u0442\u043E\u0440\u043E\u043D\u0443 \u2014 \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0432\u044B\u0431\u0440\u0430\u0442\u044C "\u043E\u0431\u0440\u0430\u0442\u043D\u044B\u0439 \u0431\u0438\u043B\u0435\u0442" \u0434\u0440\u0443\u0433\u043E\u0439 \u0430\u0432\u0438\u0430\u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438, \u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440 JetStar, KLM \u0438\u043B\u0438 \u0434\u0440\u0443\u0433\u043E\u0439... \u041D\u0435 \u0432\u044B\u0431\u0438\u0440\u0430\u0439\u0442\u0435 AirAsia. \u042D\u0442\u043E \u043D\u0435 \u043F\u043E\u0437\u0432\u043E\u043B\u0438\u0442 AirAsia \u043F\u0440\u043E\u0432\u0435\u0440\u0438\u0442\u044C, \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u0435\u043D \u043B\u0438 \u0432\u0430\u0448 \u043E\u0431\u0440\u0430\u0442\u043D\u044B\u0439 \u0431\u0438\u043B\u0435\u0442 \u043D\u0430 \u0441\u0430\u043C\u043E\u043C \u0434\u0435\u043B\u0435.'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'b',
	          null,
	          '\u0420\u0430\u0441\u043F\u0435\u0447\u0430\u0442\u0430\u0439\u0442\u0435'
	        ),
	        ' \u0432\u0430\u0448 \u043E\u0431\u0440\u0430\u0442\u043D\u044B\u0439 \u0431\u0438\u043B\u0435\u0442. \u0418 \u0432\u0441\u0435 \u043E\u0441\u0442\u0430\u043B\u044C\u043D\u044B\u0435 \u043F\u0440\u043E\u0435\u0437\u0434\u043D\u044B\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B \u0442\u043E\u0436\u0435.'
	      )
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      '\uD83D\uDE0C \u0427\u0442\u043E \u0432\u0434\u043E\u0445\u043D\u043E\u0432\u0438\u043B\u043E \u043D\u0430\u0441 \u0441\u043E\u0437\u0434\u0430\u0442\u044C \u044D\u0442\u043E\u0442 \u0441\u0430\u0439\u0442?'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u041C\u0435\u0436\u0434\u0443\u043D\u0430\u0440\u043E\u0434\u043D\u044B\u0435 \u0430\u0432\u0438\u0430\u043F\u0435\u0440\u0435\u043B\u0435\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0431\u044B\u0442\u044C \u043E\u0447\u0435\u043D\u044C \u043D\u0430\u043F\u0440\u044F\u0436\u0435\u043D\u043D\u044B\u043C\u0438, \u0438',
	      ' ',
	      data.site.siteMetadata.ru.title,
	      ' \u0441\u0442\u0440\u0435\u043C\u0438\u0442\u0441\u044F \u043F\u043E\u043C\u043E\u0447\u044C \u0432\u0430\u043C \u0441\u043E\u0445\u0440\u0430\u043D\u044F\u0442\u044C \u0441\u043F\u043E\u043A\u043E\u0439\u0441\u0442\u0432\u0438\u0435, \u0447\u0442\u043E \u0431\u044B \u043D\u0438 \u0441\u043B\u0443\u0447\u0438\u043B\u043E\u0441\u044C \u0432 \u043F\u0443\u0442\u0438. \uD83E\uDDD8'
	    ),
	    _react2.default.createElement(_Image4.default, {
	      src: 'https://media1.tenor.com/images/a1ba22175263ea13d6da30a517d6d904/tenor.gif?itemid=5626530',
	      centered: true
	    }),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u0421\u0447\u0430\u0441\u0442\u043B\u0438\u0432\u043E\u0433\u043E \u043F\u043E\u043B\u0435\u0442\u0430! \uD83D\uDC4B'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u0421 \u0443\u0432\u0430\u0436\u0435\u043D\u0438\u0435\u043C,',
	      _react2.default.createElement('br', null),
	      data.site.siteMetadata.ru.title
	    ),
	    _react2.default.createElement(
	      _Button4.default,
	      { style: { marginBottom: '3em' }, as: _gatsbyLink2.default, to: '/', color: 'green' },
	      '\u041F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0432\u0430\u0448\u0438 \u043E\u0431\u0440\u0430\u0442\u043D\u044B\u0435 \u0431\u0438\u043B\u0435\u0442\u044B ',
	      _react2.default.createElement(_Icon4.default, { name: 'arrow right' })
	    )
	  );
	};
	
	exports.default = FAQ;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-faq-ru-js-184520da18b195ca6e0d.js